import { AppShowcase } from '@/components/AppShowcase/AppShowcase'
import { type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'

type AppShowcaseBlockProps = SbBaseBlockProps<Record<string, never>>

export function AppShowcaseBlock({ blok }: AppShowcaseBlockProps) {
  return (
    <div {...storyblokEditable(blok)}>
      <AppShowcase />
    </div>
  )
}

AppShowcaseBlock.blockName = 'appShowcase'
